import clsx from "classnames";
import { Description } from "@/ui";
import classes from "../styles.module.scss";

/**
 * One expandable question/answer row. Uses native details/summary so it is keyboard accessible,
 * works without JavaScript, and keeps the answer in the HTML for search engines.
 *
 * @param {string} question - Question text shown in the clickable row.
 * @param {string} [answer] - Answer rich text revealed when the row is opened.
 * @param {boolean} [open] - Whether the row starts open.
 * @param {string} [name] - Shared group name; rows with the same name close each other when opened.
 * @param {string} [color] - Fill key for the question row.
 * @returns {JSX.Element}
 */
export default function FAQItem({ question, answer, open = false, name, color }) {
  return (
    <details className={classes.faq__item} open={open} name={name}>
      <summary className={clsx(classes.faq__question, classes[`fill--${color}`])}>
        <span className={classes.faq__icon} aria-hidden="true" />
        <span>{question}</span>
      </summary>
      {!!answer && (
        <div className={classes.faq__answer}>
          <Description description={answer} className="mb-0" />
        </div>
      )}
    </details>
  );
}
